import { ILoginResponse } from "@azm/core/interfaces/auth";
import { Roles } from "@azm/core/enums/roles";

const ROLE_CLAIM = "http://schemas.microsoft.com/ws/2008/06/identity/claims/role";
const TOKEN_LIFETIME_SECONDS = 8 * 60 * 60;

export const MOCK_USER_ROLE = Roles.FollowUpStudyEmployee;

function toBase64Url(value: object): string {
	const bytes = new TextEncoder().encode(JSON.stringify(value));
	let binary = "";
	bytes.forEach((byte) => (binary += String.fromCharCode(byte)));
	return btoa(binary).replace(/\+/g, "-").replace(/\//g, "_");
}

function createMockAccessToken(adUserName: string): string {
	const header = toBase64Url({ alg: "none", typ: "JWT" });
	const payload = toBase64Url({
		sid: "mock-user-1",
		unique_name: "1000000001",
		Email: `${adUserName}@gda.sa`,
		ADUserName: adUserName,
		FirstName: "مستخدم",
		FullName: "مستخدم تجريبي",
		[ROLE_CLAIM]: String(MOCK_USER_ROLE),
		exp: Math.floor(Date.now() / 1000) + TOKEN_LIFETIME_SECONDS,
	});
	return `${header}.${payload}.mock-signature`;
}

export function createMockLoginResponse(adUserName = "mock.user"): ILoginResponse {
	return {
		expire: new Date(Date.now() + TOKEN_LIFETIME_SECONDS * 1000).toISOString(),
		accessToken: createMockAccessToken(adUserName),
		refreshToken: "mock-refresh-token",
		displayName: "مستخدم تجريبي",
		firstName: "مستخدم",
	};
}
